<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="page_vi"></a><a id="page_vii">TABLE OF CONTENTS</a></h2><a id="page_vii">
<p class="line"><img alt="inline" src="images/line4.jpg"/></p>
</a><p class="toc-fm"><a id="page_vii"></a><span href="#/xhtml/dedication" title="Link target outside of Sample"><i>Dedication</i></span></p>
<p class="toc-fm"><a href="#/xhtml/preface"><i>Preface</i></a></p>
<p class="toc-fm"><a href="#/xhtml/ack"><i>Acknowledgments</i></a></p>
<p class="toc-part"><a href="#/xhtml/part01"><b>Section 1: A Life of Purpose Through Prosperity</b></a></p>
<p class="toc-ch"><a href="#/xhtml/chapter01"><span class="toc-lab">Chapter 1</span> Fulfilling Your Higher Purpose</a></p>
<p class="toc-ch"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><span class="toc-lab">Chapter 2</span> Customer Service is Killing Your Business</span></p>
<p class="toc-ch"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><span class="toc-lab">Chapter 3</span> The Separation of Church and Business Life</span></p>
<p class="toc-part"><span href="#/xhtml/part02" title="Link target outside of Sample"><b>Section 2: Transforming From Production to Purpose</b></span></p>
<p class="toc-ch"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><span class="toc-lab">Chapter 4</span> Time to Find the True Love In Your Life!</span></p>
<p class="toc-ch"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><span class="toc-lab">Chapter 5</span> Building Your Kingdom</span></p>
<p class="toc-ch"><span href="#/xhtml/chapter06" title="Link target outside of Sample"><span class="toc-lab">Chapter 6</span> Transforming Into a Provider</span></p>
<p class="toc-ch"><span href="#/xhtml/chapter07" title="Link target outside of Sample"><span class="toc-lab">Chapter 7</span> The Power of Wisdom</span></p>
<p class="toc-part"><a id="page_viii"></a><span href="#/xhtml/part03" title="Link target outside of Sample"><b>Section 3: Shortening Your Walk Through the Desert</b></span></p>
<p class="toc-fm"><span href="#/xhtml/part03a" title="Link target outside of Sample">Introduction</span></p>
<p class="toc-ch"><span href="#/xhtml/chapter08" title="Link target outside of Sample"><span class="toc-lab">Chapter 8</span> Falling in Love With Your Product is Killing Your Business</span></p>
<p class="toc-ch"><span href="#/xhtml/chapter09" title="Link target outside of Sample"><span class="toc-lab">Chapter 9</span> Working the Jobsite is Killing Your Business</span></p>
<p class="toc-ch"><span href="#/xhtml/chapter10" title="Link target outside of Sample"><span class="toc-lab">Chapter 10</span> Giving Out Raises is Killing Your Business</span></p>
<p class="toc-ch"><span href="#/xhtml/chapter11" title="Link target outside of Sample"><span class="toc-lab">Chapter 11</span> The Call to Fulfilling Your Purpose in the World</span></p>
<p class="toc-fm-top"><span href="#/xhtml/notes" title="Link target outside of Sample"><i>Endnotes</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8a6e25d6